import { Button, ButtonVariant } from '@dreryk/react-components';

import type { RedactionState } from '../types';
import { translationKeys } from '../translations';

type RedactButtonProps = {
   redactionState: RedactionState;
   disabled?: boolean;
   onRedact: VoidFunction;
};

export const RedactButton = (props: RedactButtonProps): JSX.Element => {
   const isLoading = props.redactionState === 'loading';
   const isDisabled = props.disabled ?? isLoading;

   const label = isLoading ? translationKeys.panel.redactButtonLoading : translationKeys.panel.redactButton;

   return (
      <Button
         testId={'redactButton'}
         label={label}
         onClick={props.onRedact}
         disabled={isDisabled}
         variant={ButtonVariant.PRIMARY}
         blockingOperation={isLoading}
         fullLength
      />
   );
};
